var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraspSqueezing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 118,
    viewBox: "0 0 135 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2386_15875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.055 54.2598C67.4887 54.815 71.878 53.6029 77.1923 57.0564C85.5184 62.4737 80.4978 64.4849 92.5985 88.3413C99.3512 101.654 85.3023 101.377 79.7279 103.059",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6274 58.0844C55.0368 63.996 37.3178 67.69 28.5799 58.7988C24.7849 54.9356 21.0642 56.0191 17.8296 56.747C7.99098 58.9546 3.47682 77.7695 1.28558 97.2853C1.25179 97.5809 1.23488 97.8783 1.23494 98.1758L1.23494 101.965C1.23474 102.518 1.34521 103.066 1.55982 103.577C1.77444 104.087 2.08885 104.549 2.48448 104.935C2.88011 105.321 3.34893 105.624 3.86326 105.826C4.37759 106.028 4.92698 106.124 5.47899 106.109L18.6973 105.746",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6929 79.6523C71.2298 80.1907 73.0732 86.3055 74.9606 92.9416C78.1378 104.115 76.8851 103.874 76.5846 115.495",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0835 85.0938C20.8781 89.4953 19.6694 115.481 19.6694 115.481",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.443 53.4335C120.2 53.3568 119.937 53.3799 119.711 53.4978C119.397 53.664 118.572 53.5875 118.28 53.789C117.233 54.1885 116.405 54.351 115.382 54.6253C115.335 54.6253 115.294 54.6523 115.25 54.6659C115.595 54.3269 115.981 54.0323 116.398 53.789C117.764 52.9681 119.391 52.7017 120.946 53.0441C120.742 53.1185 120.567 53.2545 120.443 53.4335Z",
    fill: "#237FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.765 60.4547C112.796 60.2617 112.829 60.0416 112.87 59.7979C114.432 60.131 116.057 60.0052 117.55 59.4356C119.95 58.5214 122.337 57.4655 122.624 54.828C122.638 54.6984 122.262 53.6526 122.226 53.5273C123.137 54.0826 123.576 54.9629 124.667 56.5746C124.549 57.8206 124.19 59.0317 123.61 60.1398C123.546 60.2552 123.504 60.3815 123.485 60.5123C123.202 60.9321 122.918 61.3486 122.624 61.765C121.885 62.8214 123.613 63.8168 124.346 62.7808L124.518 62.5302C124.682 62.5842 124.859 62.5896 125.026 62.5458C125.193 62.5019 125.344 62.4107 125.46 62.2831L125.548 62.2018C125.511 62.256 125.474 62.3067 125.44 62.3609C124.866 63.2886 124.164 64.345 123.88 65.4081C123.67 65.5754 123.473 65.7576 123.289 65.9533C122.422 66.8979 123.826 68.3233 124.701 67.3685C125.832 66.1361 127.493 65.7433 129.032 65.1407C127.321 66.8121 125.753 68.6242 124.343 70.558C123.667 71.4857 124.974 72.3795 125.801 71.8141C126.036 71.8765 126.286 71.8474 126.5 71.7328C127.935 71.015 129.816 70.5546 131.153 69.5151C130.295 72.278 127.5 73.805 123.725 73.7339C116.898 73.6289 111.833 67.6766 112.765 60.4547Z",
    fill: "#237FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.204 55.1762C128.685 53.5578 131.636 58.5959 133 63.3022C133.361 64.5583 133.172 66.7219 131.808 68.6078C129.499 71.804 124.475 72.2543 123.999 71.3164C123.826 70.9778 124.13 70.2194 126.362 68.347",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.803 65.3651C124.12 67.979 123.401 67.6641 122.992 67.1122C122.731 66.7601 123.344 65.7624 124.832 64.1191",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.118 60.8995C122.891 63.9942 123.043 63.5269 122.574 63.0326C122.247 62.6872 122.836 61.4661 124.339 59.3691",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.658 63.8581C111.709 61.7487 112.728 55.2751 114.754 54.5979C117.118 53.9207 119.481 53.5821 121.845 52.5664C123.533 54.2593 122.182 56.6294 120.832 57.9837C119.143 59.6766 116.216 60.198 114.079 59.8594",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5256 96.7136C100.039 93.2814 104.209 89.4181 107.978 85.1782C110.679 82.0666 112.664 78.0307 114.055 74.1607C114.608 72.5793 114.868 70.9096 114.821 69.2344",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.043 78.0078C115.628 88.6122 109.649 97.1478 104.882 103.527C99.1418 111.185 95.3738 115.492 90.3836 115.377C86.5886 115.306 83.5498 112.719 81.6523 110.637",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.325 39.7246L121.733 47.8336",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "5 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.234 39.9336L117.114 48.3202",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "5 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.169 44.6836L112.191 50.0806",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "5 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.215 44.1797L128.091 50.5823",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "5 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.243 53.7812L108.68 56.4493",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "5 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.34033 107.449L5.34033 114.715",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5864 27.0566C67.5864 27.0566 66.1515 43.0004 57.7613 45.2215C49.3711 47.4426 45.2148 41.6732 45.2148 41.6732",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9831 26.4414C59.9831 26.78 60.9522 29.3938 61.6713 32.16C61.7126 32.3165 61.7161 32.4806 61.6814 32.6387C61.6466 32.7967 61.5747 32.9442 61.4717 33.0687C61.3686 33.1933 61.2373 33.2913 61.0888 33.3547C60.9403 33.4181 60.7789 33.445 60.6179 33.4331C59.6691 33.3485 58.4841 33.0945 57.9506 32.3192",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7305 24.4161C41.1936 23.2649 39.8971 21.7481 38.7762 22.0054C37.3378 22.344 37.1319 25.3709 37.088 25.7772C37.0441 26.4544 36.8618 29.1292 38.8741 30.9507C39.6162 31.6126 40.5204 32.0648 41.4941 32.261",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8498 36.5352C40.0659 39.2641 36.5613 47.4612 33.9919 53.5624",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6743 48.1074C56.5104 51.469 56.0425 54.8087 55.2765 58.0854",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.787 22.9785C49.0031 23.3002 50.357 25.2673 52.7846 25.5145C53.6334 25.5972 54.4894 25.4681 55.2764 25.1387",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2791 25.6895C62.7168 26.2467 63.3179 26.652 63.9976 26.8482C64.6773 27.0445 65.4013 27.0217 66.0674 26.7831",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0022 19.9953C39.5849 18.2236 39.6726 16.3699 40.2554 14.6458C40.4209 14.1616 39.1548 10.1562 41.7984 8.40911C44.5535 6.58755 43.6385 5.81897 47.4133 3.78748C49.1588 2.84961 48.8415 2.59229 50.7187 1.58671C52.0355 0.875686 59.1595 2.90717 62.5359 2.84623C64.4638 2.80898 67.5531 2.75143 69.535 4.86079C70.8282 6.23543 71.2941 8.15179 71.6014 9.4147C71.9998 11.05 71.6419 11.1076 71.993 12.3908C72.7088 15.0081 74.272 15.4821 74.9946 17.544C75.3626 18.5869 75.5719 20.2087 74.6569 22.6024",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2057 21.9316C45.3671 18.3088 43.5068 17.4217 44.9147 16.5482C47.2782 15.0754 49.0609 16.5821 50.0873 14.7605C50.8132 13.4807 49.044 11.8182 48.6557 10.7246",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6553 10.7246C49.2327 11.1444 57.3325 12.2381 58.5108 12.9626C62.9541 15.6984 64.9259 15.7525 66.6478 17.4657C67.7654 18.5729 69.0112 20.601 69.0518 24.6132",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7533 36.7261C50.876 37.0922 51.6806 39.3455 53.9619 40.216C54.7593 40.5165 55.6184 40.6143 56.4622 40.5005",
    stroke: "#615F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2386_15875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134,
    height: 117,
    fill: "white",
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 134.722 0.925781)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraspSqueezing);
export default __webpack_public_path__ + "static/media/grasp_squeezing.b3e99ce918f892a84e4fadef6ec2c5b3.svg";
export { ForwardRef as ReactComponent };